/* global NG_BUILD_MICROAPP_NAME, __webpack_require__ */
(function setPublicPath() {
  const appName = NG_BUILD_MICROAPP_NAME;
  const script = document.currentScript || document.querySelector(`script[src*="${appName}"]`);
  let url = script.src.split('/');

  url.pop();
  url.pop();
  url = url.join('/');

  // eslint-disable-next-line camelcase
  __webpack_require__.p = `${url}/`;
})();
